
<pill :class="['badge', { clickable }]" :active="active" readonly>
  <icon v-if="icon" :class="['icon', { 'has-label': Boolean(label) }]" :name="icon" />
  <span v-if="label" class="label">{{ label }}</span>
</pill>
